import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import {ItineraryService} from "../../../core/services/itinerary.service";

@Component({
  selector: 'app-view-agent',
  templateUrl: './view-agent.component.html',
  styleUrls: ['./view-agent.component.scss'],
})
export class ViewAgentComponent implements OnInit {
   agent: any;
   b2b: any;
   contact: any;
   currency: any;
  @Input() id: any;
  loading = false;

  constructor(
    private itineraryService: ItineraryService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.getItineraryByID().then( r => {
      this.loading = false;
    });
  }


  async getItineraryByID(): Promise<void> {
    try {
      const  {tour, b2b} = await this.itineraryService.getItineraryById({
        id: this.id,
      });
      this.agent = tour?.agent || null;
      this.contact = tour?.selectedContact || null;
      this.b2b =  b2b;
      this.currency = tour?.currency;
    } catch (e) {
    }
  }

  getEmptyValue(): string {
    return this.translocoService.translate('itineraries.viewAgent.emptyValue');
  }

  getUpdatedCostingTitle(): string {
    const isCustom = this.b2b?.costing?.viewType === 'custom';
    return isCustom
      ? this.translocoService.translate('itineraries.viewAgent.updatedCostingCustom')
      : this.translocoService.translate('itineraries.viewAgent.updatedCosting');
  }
}
